export * from './menu-layout';



import { MenuLayoutComponent } from './menu-layout';


export const LayoutAtoms = [
    MenuLayoutComponent,
    
]